import React from 'react';

function Header({ subtitle }) {
  return (
    <header className="app-header">
      <div className="app-header__logo">EMILIO MORO</div>
      <div className="app-header__subtitle">{subtitle || 'BODEGAS'}</div>
    </header>
  );
}

export default Header;
